import React from 'react';

export default function MonzoRound() {
  return (
    <svg width="71" height="71" viewBox="0 0 71 71">
      <circle fill="#fff" cx="35.5" cy="35.5" r="35.5" />
      <path
        d="M56.257 44.808c0 .498-.199.976-.554 1.328l-8.466 8.41c-.476.473-1.291.138-1.291-.531v-18.845l10.193-10.069h.118v19.707"
        fill="#E83860"
        fillRule="nonzero"
      />
      <path
        d="M49.501 18.39c-.295-.293-.774-.293-1.069 0l-12.589 12.505h-.175v14.114l.175.371 10.104-10.037 10.311-10.243-6.756-6.711"
        fill="#DFC586"
        fillRule="nonzero"
      />
      <path
        d="M15.427 44.808c0 .498.199.976.554 1.328l8.466 8.41c.476.473 1.291.138 1.291-.531v-18.845l-10.194-10.069h-.118v19.707"
        fill="#16788D"
        fillRule="nonzero"
      />
      <path
        d="M23.253 18.39c-.295-.293-.774-.293-1.069 0l-6.756 6.711 10.311 10.243 10.104 10.037v-14.485l-12.589-12.505"
        fill="#8ABB9C"
        fillRule="nonzero"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/MonzoRound/index.js